import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sinkhole-coverage-exclusion',
  templateUrl: './sinkhole-coverage-exclusion.component.html',
  styleUrls: ['./sinkhole-coverage-exclusion.component.scss']
})
export class SinkholeCoverageExclusionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
